var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { I18nService } from '@/services/i18n-service';
import formatDate from '../../formatDate';
let DateFormatterServiceImpl = class DateFormatterServiceImpl {
    constructor(_i18nService) {
        this._i18nService = _i18nService;
    }
    get _locale() {
        return this._i18nService.locale;
    }
    formatDate(date) {
        return formatDate(date);
    }
};
DateFormatterServiceImpl = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object])
], DateFormatterServiceImpl);
export { DateFormatterServiceImpl };
